import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom'; // Import NavLink instead of Link
import './Navbar.css';
import { FaSun, FaMoon, FaPhone, FaEnvelope, FaMapMarkerAlt, FaSearch, FaBars, FaTimes } from 'react-icons/fa';
import LogoLight from './images/astrasightLogo.png';
import LogoDark from './images/astrasigtsWhiteLogo.png';


const Navbar = ({ isDarkMode, toggleTheme }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showUtilityBar, setShowUtilityBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowUtilityBar(false); // Hide utility bar
      } else {
        setShowUtilityBar(true); // Show utility bar
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <header>
      {/* Utility Bar */}
      <div className={`utility-bar ${isDarkMode ? 'dark' : 'light'} ${showUtilityBar ? 'show' : 'hide'}`}>
        <div className="contact-info">
          <span><FaPhone /> +254 7918 65638</span>
          <span><FaEnvelope /> info@astrasighttech.com</span>
          <span><FaMapMarkerAlt /> Gracewood Plaza Kikuyu</span>
        </div>
        <div className="search-container utility-search">
          <input type="text" placeholder="Search..." />
          <button className="search-icon"><FaSearch /></button>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className={`navbar ${isDarkMode ? 'dark' : 'light'} ${!showUtilityBar ? 'top' : ''}`}>
       <div className="navbar-logo">
<div className="navbar-logo">
  <img
    src={isDarkMode ? LogoDark : LogoLight}
    alt="AstraSight Logo"
    className="logo-img"
  />
</div>

</div>


        <ul className={`navbar-links ${menuOpen ? 'active' : ''}`}>
          <li>
            <NavLink
              exact
              to="/"
              className="nav-link"
              activeClassName="active"
              onClick={toggleMenu}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/About"
              className="nav-link"
              activeClassName="active"
              onClick={toggleMenu}
            >
              About
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/Services"
              className="nav-link"
              activeClassName="active"
              onClick={toggleMenu}
            >
              Services
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/Contact"
              className="nav-link"
              activeClassName="active"
              onClick={toggleMenu}
            >
              Contact
            </NavLink>
          </li>

             <li>
            <NavLink
              to="/Blog"
              className="nav-link"
              activeClassName="active"
              onClick={toggleMenu}
            >
              BlogPage
            </NavLink>
          </li>
               <li>
            <NavLink
              to="/Products"
              className="nav-link"
              activeClassName="active"
              onClick={toggleMenu}
            >
              Products
            </NavLink>
          </li>
        </ul>

        {/* Theme Toggle Button for Large Screens */}
        <button className="theme-toggle-large" onClick={toggleTheme}>
          {isDarkMode ? <FaSun /> : <FaMoon />}
        </button>

        {/* Search Bar for Small Screens */}
        <div className="search-container navbar-search">
          <input type="text" placeholder="Search..." />
          <button className="search-icon"><FaSearch /></button>
        </div>

        {/* Theme Toggle Button for Small Screens */}
        <button className="theme-toggle-small" onClick={toggleTheme}>
          {isDarkMode ? <FaSun /> : <FaMoon />}
        </button>

        {/* Hamburger Menu Button */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
